import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum CriteriaPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const CriteriaResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.CRITERIA).default(ResourceType.CRITERIA),
    description: z.string(),
});
export const CriteriaMutationResourceSchema = getMutationSchema(CriteriaResourceSchema);

export type CriteriaResource = z.infer<typeof CriteriaResourceSchema>;

export const defaultCriteriaResource: CriteriaResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.CRITERIA,
    description: '',
};

export function useCriteriaActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/criteria',
            ResourceType.CRITERIA,
            CriteriaResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter('project/criteria', ResourceType.CRITERIA, CriteriaResourceSchema),
    };
}
